// extracted by mini-css-extract-plugin
module.exports = {"fontModalDivider":"style_fontModalDivider__21G4Y","fontModalDividerLine":"style_fontModalDividerLine__n_vRK","fontModalDividerText":"style_fontModalDividerText__24Pps"};